import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { accentColors, lighterVariations, secondaryColors } from '@tryhackme/thm-ui-components';

import { StatusTagEnum } from './status-tag.types';

export const StyledStatusTag = styled.span<{ $status: StatusTagEnum; $isDark: boolean }>`
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  font-family: ${({ theme }) => theme.fonts.familyUbuntu};
  font-weight: ${({ theme }) => theme.fonts.weight.regular};
  display: flex;
  align-items: center;
  gap: 0.5rem;
  width: fit-content;
  height: 3rem;
  padding: 1rem;
  border-radius: ${({ theme }) => theme.radius.huge};
  color: ${({ $isDark }) => ($isDark ? secondaryColors.grey[100] : secondaryColors.black)};
  background-color: ${({ $status, $isDark }) => {
    const lightStatusTagColors = {
      [StatusTagEnum.ALL_COMPLETED]: lighterVariations.success.lighter,
      [StatusTagEnum.HIGH_COMPLETION]: lighterVariations.blue.light,
      [StatusTagEnum.LOW_COMPLETION]: lighterVariations.warning.lighter,
      [StatusTagEnum.NOT_STARTED]: secondaryColors.grey[200],
      [StatusTagEnum.NOT_TAGGED]: secondaryColors.grey[400],
    };

    const darkStatusTagColors = {
      [StatusTagEnum.ALL_COMPLETED]: lighterVariations.success.dark,
      [StatusTagEnum.HIGH_COMPLETION]: lighterVariations.blue.darker,
      [StatusTagEnum.LOW_COMPLETION]: lighterVariations.warning.dark,
      [StatusTagEnum.NOT_STARTED]: secondaryColors.grey[800],
      [StatusTagEnum.NOT_TAGGED]: secondaryColors.secondary.lighter,
    };

    return $isDark ? darkStatusTagColors[$status] : lightStatusTagColors[$status];
  }};
`;

export const StyledStatusIcon = styled(FontAwesomeIcon)<{ $status: StatusTagEnum; $isDark: boolean }>`
  color: ${({ $status, $isDark }) => {
    const lightStatusTagColors = {
      [StatusTagEnum.ALL_COMPLETED]: accentColors.success.light,
      [StatusTagEnum.HIGH_COMPLETION]: accentColors.info.light,
      [StatusTagEnum.LOW_COMPLETION]: accentColors.warning.lighter,
      [StatusTagEnum.NOT_STARTED]: secondaryColors.grey[600],
      [StatusTagEnum.NOT_TAGGED]: secondaryColors.grey[800],
    };

    const darkStatusTagColors = {
      [StatusTagEnum.ALL_COMPLETED]: accentColors.success.dark,
      [StatusTagEnum.HIGH_COMPLETION]: accentColors.info.dark,
      [StatusTagEnum.LOW_COMPLETION]: accentColors.warning.dark,
      [StatusTagEnum.NOT_STARTED]: secondaryColors.grey[400],
      [StatusTagEnum.NOT_TAGGED]: secondaryColors.grey[600],
    };

    return $isDark ? darkStatusTagColors[$status] : lightStatusTagColors[$status];
  }};
`;
